export const DEFAULT_COLLECTION_COVER_IMAGE = "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/affiliate/default-collection-cover.webp";
